module.exports = "/packs/images/navigation/calculator@3x-b7510df1577d29f98fdf54a71c78e056.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/calculator@3x.jpg
// module id = 1812
// module chunks = 0